import React, { Component } from 'react';
import { general } from '../consts.js';
import urijs from 'urijs';
import cartApi from '../../cartApi.js';
import providerEvents from 'wix-art-store-3rd-party/dist/src/sdk/providerEvents';
import { utils } from '../../../utils/utils';
import * as styles from './ProviderStyles.js';
import WixStoreApi from '../../storeApi';

class ProviderIntent extends Component {
  constructor(props) {
    super(props);
    this.handleMessageReceived = this.handleMessageReceived.bind(this);
    this.onBackToEditor = this.onBackToEditor.bind(this);
    this.handleWixStyleChanged = this.handleWixStyleChanged.bind(this);
    this.setTabIndex = this.setTabIndex.bind(this);

    let anonymousUserId = null;
    let providerData = null;
    let providerId = null;
    let debugApp = window.debugApp;
    const connectedProviders = props.connectedProviders;

    if (window.Wix) {
      anonymousUserId = Wix.Utils.getInstanceValue('aid');
    }

    if (connectedProviders) {
      const providerDataProps = this.getProviderDataFromConnectedProviders(connectedProviders);
      providerData = providerDataProps.providerData;
      providerId = providerDataProps.providerId;
    }

    this.state = {
      providerData: providerData,
      providerId: providerId,
      token: utils.getUUID(),
      anonymousUserId,
      isAccessible: utils.isAccessibilityEnabled(),
      providerReady: false,
      debugApp: debugApp
    }
  }

  isDashboard() {
    return Wix.Utils.getViewMode() === 'dashboard';
  }

  isEditor() {
    return Wix.Utils.getViewMode() === 'editor';
  }

  handleWixStyleChanged(e) {
    // This timeout will let the params a chance to be set
    setTimeout(() => {
      this.sendStylesToProvider();
    }, 1);
  }

  getProviderDataFromConnectedProviders(connectedProviders) {
    let providerData = null;
    let providerId = null;

    if (connectedProviders) {
      providerId = Object.keys(connectedProviders)[0];
      providerData = connectedProviders[providerId];
    }

    return { providerData, providerId };
  }

  // componentWillMount() {
  //   if (window.Wix) {
  //     if (!this.state.providerData) {
  //       window['WixStoreApi'].getStoreGalleryData()
  //         .then((storeGalleryData) => {
  //           const providerData = this.getProviderDataFromConnectedProviders(storeGalleryData.connectedProviders);
  //           this.setState(providerData);
  //           this.forceUpdate();
  //         });
  //     }
  //   }
  // }

  raiseEvent(eventType, data, resolve, reject) {
    if (this.props.onMessageReceived) {
      this.props.onMessageReceived(eventType, data, resolve, reject, this.state.providerId);
    }
  }

  setTabIndex(idx) {
    if (this.intentFrame) {
      this.intentFrame.tabIndex = idx;
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !this.intentFrame //prevent iframe from refreshing
  }

  componentDidMount() {
    window.addEventListener('message', this.handleMessageReceived);
    Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, this.onBackToEditor);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessageReceived);
    Wix.removeEventListener(Wix.Events.EDIT_MODE_CHANGE, this.onBackToEditor);
  }

  addToCart({ originalUrl, itemId, itemUrl, itemType, galleryId }) {
    var dataToSend = {
      originalUrl,
      itemId,
      itemUrl,
      itemType,
      galleryId
    };
    cartApi.publishAddToCart(dataToSend)
  }

  onBackToEditor() {
    if (this.props.hiddenFromEditor === true && !utils.isSite()) {

      // If we don't do the following checks then if the hidden page is not visible, the SDK will make a short jump to that page before navigating to home..
      // This way we make sure that the current pageId is not a hidden page - thus we should not navigate at all..
      Wix.getCurrentPageId(currentPageId => {
        Wix.getSitePages(arrPages => {
          const isInSitePages = arrPages.some(page => {
            return page.id === currentPageId;
          });
          if (!isInSitePages) {
            this.backHome();
          }
        });
      });
    }
  }

  backHome(payload) {
    if (!utils.isEditor()) {
      try {
        Wix.replaceSectionState('/')
      } catch (e) {
        console.error('failed replacing section state', e);
      }
    }
    Wix.getSitePages(arrPages => {
      const homepage = (arrPages || [])
        .find(page => {
          return page.isHomepage;
        });
      if (homepage) {
        const homepageId = homepage.id;
        if (payload) {
          if (payload.openCart) {
            localStorage.setItem('openCart', true);
          }
        }

        Wix.navigateToPage(homepageId);
      }
    });
  }

  getSiteUrlsBundle() {
    const arrPromises = [];
    let returnPromise = null;
    if (!this.isDashboard()) {
      let dashboardPromise = Promise.resolve(null);

      arrPromises.push(new Promise((resolve, reject) => {
        Wix.getSiteInfo(info => {
          resolve(info);
        });
      }));

      arrPromises.push(new Promise((resolve, reject) => {
        Wix.Utils.getSectionUrl({ sectionId: 'checkout_page' }, data => {
          resolve(data);
        });
      }));

      arrPromises.push(new Promise((resolve, reject) => {
        Wix.Utils.getSectionUrl({ sectionId: 'thank_you_page' }, data => {
          resolve(data);
        });
      }));

      if (this.isEditor()) {
        dashboardPromise = new Promise((resolve, reject) => {
          Wix.Settings.getDashboardAppUrl(function (url) {
            // For some reason - the value does not have the protocol section ( http: ), so we add it ourselves..
            resolve(urijs(url).protocol('http').search({ appState: '#' }).toString());
          });
        });
      }
      arrPromises.push(dashboardPromise);

      returnPromise = Promise.all(arrPromises).then(results => {
        const siteUrl = results[0].baseUrl;
        const url = results[0].url;
        const checkoutUrl = urijs(results[1].url).search({}).toString();
        const thankYouUrl = urijs(results[2].url).search({}).toString();
        const dashboardUrl = results[3];
        return {
          checkoutUrl,
          thankYouUrl,
          siteUrl,
          url,
          dashboardUrl
        };
      });
    } else {
      returnPromise = Promise.reject('Cannot get urls when viewMode is "dashboard"');
    }

    return returnPromise;
  }

  sendStylesToProvider() {
    styles.getStyles(this.props.styleParams)
      .then(css => {
        this.postMessage(providerEvents.css, css);
      });
  }

  handleMessageReceived(event) {
    const {
      intent,
    } = this.props;
    const {
      providerData,
    } = this.state;

    if (event.data && (event.data.type == Wix.Events.STYLE_PARAMS_CHANGE)) {
      this.handleWixStyleChanged();
    }
    // This check is because the provider may get messages that did not originate from the provider.. So we might get messages before the provider is loaded.
    if (providerData) {
      const {
        widgets
      } = providerData;
      const origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
      const data = event.data;
      const intentUrl = widgets[intent].url;
      if (intentUrl.indexOf(origin) === 0) {
        const {
          type,
          token,
          payload,
          callbackId
        } = data;

        let resolve = () => {};
        let reject = () => {};
        if (callbackId) {
          resolve = (payload) => {
            this.postMessage(providerEvents.callback, { payload, callbackId, resolved: true });
          }
          reject = (payload) => {
            this.postMessage(providerEvents.callback, { payload, callbackId, resolved: false });
          }
        }
        try {
          if (this.state.token && (token === this.state.token)) {
            if (process.env.NODE_ENV === 'development') {
              console.log(`taltaltal - Provider intent message received: type: ${type} | intent ${intent}`);
            }
            switch (type) {
              case providerEvents.sdkReady:
                if (this.loader) {
                  $(this.loader).hide();
                }
                this.setState({ providerReady: true }, () => {
                  this.sendStylesToProvider();
                });
                break;
              case providerEvents.backHome:
                this.backHome(payload);
                break;
              case providerEvents.navigateToUrl:
                const { url } = payload;
                window.top.location.href = url;
                break;
              case providerEvents.getSiteUrls:
                this.getSiteUrlsBundle().then(urls => {
                  resolve(urls);
                }).catch(err => {
                  reject(err);
                });
                break;
              case providerEvents.getStyles:
                styles.getStyles(this.props.styleParams).then(data => resolve(data))
                break;
              default:
                break;
            }

            this.raiseEvent(type, payload, resolve, reject, providerData.providerId);
          }
        } catch (error) {
          console.error(`Error handling provider event. Type: ${type} | payload: ${payload}`, error);
          if (reject) {
            reject('Error');
          }
        }
      }
    } else {
      // TODO: do something smart
    }
  }

  postMessage(type, payload) {
    const {
      intent,
    } = this.props;

    const { providerData, token } = this.state;
    const { widgets } = providerData;
    let success = false;
    if (this.intentFrame && type && payload) {
      const obj = { type, token, payload };
      const { providerReady } = this.state;
      const window = this.intentFrame.contentWindow;
      if (providerReady) {
        this.intentFrame.contentWindow.postMessage(obj, widgets[intent].url);
        success = true;
      } else {
        // console.error(`cannot send provider message - type: ${type} | intent: ${intent} | payload:`, payload);
      }
    }
    return success;
  }

  onFrameCreated(element) {
    this.intentFrame = element;
    if (this.props.onFrameCreated) {
      this.props.onFrameCreated();
    }
  }

  getProviderBaseUrl() {
    let url = null;
    const { providerData } = this.state;
    const { intent } = this.props;

    if (providerData && intent) {
      const { widgets } = providerData;
      if (widgets) {
        const baseUrl = widgets[intent];
        url = baseUrl.url;
      }
    }

    return url;
  }

  render() {
    const {
      providerData,
      anonymousUserId,
      debugApp
    } = this.state;

    if (!providerData || !providerData.widgets) {
      return (<div className="circle-preloader"></div>);
    }

    const {
      intent,
      locale,
      deviceType,
      viewMode,
      additionalParams,
      additionalPath,
      tabIndex
    } = this.props;

    if (!deviceType) {
      console.warn('no device type! TODO: take from url')
    }

    var {
      providerId,
      signedInstance
    } = providerData;

    const urlAdditionalParams = urijs(window.location.href).search(true).additionalParams;
    let objUrlAdditionalParams = {};
    if (urlAdditionalParams) {
      objUrlAdditionalParams = URI('/').search(urlAdditionalParams).search(true);
    }

    const realLocale = locale || Wix.Utils.getLocale();
    const realDeviceType = deviceType || Wix.Utils.getDeviceType();
    const cachekiller = Date.now()
    const url = this.getProviderBaseUrl();
    const realViewMode = viewMode || Wix.Utils.getViewMode();
    const realAdditionalParams = additionalParams || {};
    if (providerId === '147bec5f-d87e-d37b-b5cf-36f47c1815b4' || providerId === '14a0ee97-918b-2f0c-43f1-42e67948716b') {
      // This is specific to the Wix provider.
      realAdditionalParams.biToken = Wix.Utils.getInstanceValue('biToken');
    }
    if (debugApp) {
      realAdditionalParams.debugApp = debugApp;
    }
    const fullUrl = urijs(url)
      .segment(additionalPath || '')
      .search(Object.assign({
        pInstance: signedInstance,
        locale: realLocale,
        deviceType: realDeviceType,
        cachekiller,
        anonymousUserId,
        viewMode: realViewMode,
        a11y: this.state.isAccessible,
        token: this.state.token,
      }, realAdditionalParams || {}, objUrlAdditionalParams));
    const id = intent + '-frame';
    const iframeIndex = tabIndex || -1;
    const renderComponent = (<iframe
        tabIndex={iframeIndex}
        src={fullUrl}
        id={id}
        ref={r => this.onFrameCreated(r)}
      />);

    return (
      <div className={'provider-intent-wrapper'}>
        <div className="circle-preloader" ref={ref => this.loader = ref}/>
        {renderComponent}
      </div>
    );
  }
}

ProviderIntent.defaultProps = {
  styleParams: {},
}

export default ProviderIntent;



// WEBPACK FOOTER //
// ./store/applications/components/ProviderIntent.js